module.exports = __webpack_public_path__ + "static/img/4-bg.4fd8ed4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/4-bg.png
// module id = JnIH
// module chunks = 0